import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import AirService from '@/service/AirService';

export const useAirPortionStore = defineStore('airPortion', {
  state: () => ({
    gatewayAir: [],
    destinationAir: [],
    airPortCode: [],
    listFlightInformation: [] as any[],
    isLoading: false
  }),
  getters: {
    selectAirportCode: (state) => state.airPortCode,
    selectGateway: (state) => state.gatewayAir,
    selectDestination: (state) => state.destinationAir,
    selectFlightInformation: (state) => state.listFlightInformation,
    selectIsLoading: (state) => state.isLoading
  },
  actions: {
    async getFlightInformation(payload) {
      this.isLoading = true;
      try {
        const airService = new AirService();
        const res = await airService.getFlightInformation(payload);
        this.updateFlightInformation(res.data);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        const store = useIndexStore();
        this.updateFlightInformation([]);
        store.updateNotification(e);
      }
    },
    async searchFlightOptionJaw(payload: any) {
      this.isLoading = true;
      try {
        const airService = new AirService();
        const res = await airService.searchFlightOptionJaw(payload);
        this.updateFlightInformation(res.data);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        const store = useIndexStore();
        this.updateFlightInformation([]);
        store.updateNotification(e);
      }
    },
    async searchFlightOptionOneWay(payload: any) {
      this.isLoading = true;
      try {
        const airService = new AirService();
        const res = await airService.searchFlightOptionOneWay(payload);
        this.updateFlightInformation(res.data);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        const store = useIndexStore();
        this.updateFlightInformation([]);
        store.updateNotification(e);
      }
    },
    async generateQuoteId() {
      try {
        const airService = new AirService();
        const res = await airService.generateQuoteId();
        return res.data;
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    updateFlightInformation(payload: any) {
      this.listFlightInformation = [...this.listFlightInformation, ...payload];
    },
    clearListFlightInformation() {
      this.listFlightInformation = [];
    },
    updateAirportCode(payload) {
      this.airPortCode = payload;
    },
    async getListAirPort() {
      const airService = new AirService();
      try {
        const res = await airService.getListAirportCode();
        if (res) {
          this.updateAirportCode(res.data);
        }
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    }
  }
});
